import { render, staticRenderFns } from "./loanInfo.vue?vue&type=template&id=4b20e050&scoped=true&"
import script from "./loanInfo.vue?vue&type=script&lang=js&"
export * from "./loanInfo.vue?vue&type=script&lang=js&"
import style0 from "./loanInfo.vue?vue&type=style&index=0&id=4b20e050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20e050",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VDatePicker,VMenu,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b20e050')) {
      api.createRecord('4b20e050', component.options)
    } else {
      api.reload('4b20e050', component.options)
    }
    module.hot.accept("./loanInfo.vue?vue&type=template&id=4b20e050&scoped=true&", function () {
      api.rerender('4b20e050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale-nc/drop-out/components/loanInfo.vue"
export default component.exports